import * as React from "react";
import { useFormikContext } from "formik";
import { Heading, Stack } from "@origin-digital/ods-core";
import FormFieldLayout from "../FormComponents/FormFieldLayout";
import RequestorInfo from "../RequestorInfo";
import ReadOnlyTextField from "../FormComponents/ReadOnlyTextField";
import ReadOnlyUploadedFile from "../FormComponents/ReadOnlyUploadedFile";
import { RemoveSupplyFormValues } from "./types";

const RemoveSupplyServiceBlockReadonly: React.FC = () => {
  const { values } = useFormikContext<RemoveSupplyFormValues>();
  const attachment = values.abolishmentForm?.[0];

  return (
    <Stack
      space={{
        xs: "xlarge",
        md: "xxlarge",
      }}
    >
      {(values.abolishmentDate || attachment) && (
        <Stack
          space={{
            xs: "xlarge",
            md: "xxlarge",
          }}
          id="removeDetailsSection"
        >
          <FormFieldLayout multipleFields>
            <Heading variant="h4">Removal details</Heading>
            <ReadOnlyTextField
              label="Proposed date of removal of supply"
              value={
                values.abolishmentDate
                  ? values.abolishmentDate.toLocaleDateString()
                  : ""
              }
            />
          </FormFieldLayout>

          {attachment && (
            <FormFieldLayout>
              <ReadOnlyUploadedFile
                key={attachment.attachmentId}
                attachment={attachment}
              />
            </FormFieldLayout>
          )}
        </Stack>
      )}
      {values.networkFormNumber && (
        <Stack
          space={{
            xs: "xlarge",
            md: "xxlarge",
          }}
          id="supportingDocumentsSection"
        >
          <FormFieldLayout multipleFields>
            <Heading variant="h4">Supporting documents</Heading>
            <ReadOnlyTextField
              label="Distributor request ID"
              value={values.networkFormNumber ?? ""}
            />
          </FormFieldLayout>
        </Stack>
      )}
      <FormFieldLayout>
        <RequestorInfo
          requesterName={values.requester || ""}
          submittedDateTime={values.submittedDateTime || ""}
        />
      </FormFieldLayout>
    </Stack>
  );
};

export default RemoveSupplyServiceBlockReadonly;
